import {store} from '../../store'
import {httpgst} from '../../main'

const state = {}

const getters = {}

const actions = {
  getAction ({ commit, dispatch }, payload) {
    let searchExpensesId = payload.event.context.searchExpensesId;
    let baseUrl = 'api/expenses-company-status/' + payload.event.company + '/6';

    if (searchExpensesId && searchExpensesId > 0) {
      baseUrl += `?expense_id=${searchExpensesId}`;
    } else {
      baseUrl += `?start_date=${payload.event.context.startDate}&end_date=${payload.event.context.endDate}`;
    }

    let url = baseUrl;

    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGet', { event: payload.event, response: response })
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getDownload ({ commit, dispatch }, payload) {
    let url = `api/expenses-report/${payload.event.company_id}?status=6&type=download&startDate=${payload.event.context.startDate}&endDate=${payload.event.context.endDate}`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }

    let params = {
      responseType: 'blob'
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, params, options)
      .then(
        response => {
          commit('onGetDownload', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  downloadLayout ({ commit, dispatch }, payload) {
    let typeDocument = payload.event.typeArchive
    let url = `api${payload.event.url}`
    let params = {expenses: payload.event.listId}
    let config = {}
    let configParams = {}
    if (typeDocument === 'txt' || typeDocument === 'xml') {
      config = { responseType: typeDocument }
    } else {
      configParams = {responseType: 'blob'}
      config = { emulateJSON: false, headers: { 'Content-Type': 'application/vnd.ms-excel' } }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    // Utilizar una función para formatear los parámetros
    const formatParams = (params) => {
      return Object.keys(params)
        .map(key => Array.isArray(params[key]) ? params[key].map(val => `${key}[]=${val}`).join('&') : `${key}=${params[key]}`)
        .join('&')
    }
    // Concatenar los parámetros directamente a la URL
    if (Object.keys(params).length > 0) {
      url += `?${formatParams(params)}`
    }
    httpgst.get(url, configParams, config)
      .then(
        response => {
          commit('onDownloadFilesERPZip', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
}

// mutations
const mutations = {
  // Set the data obtained from the expensesItems endpoint
  onGet (state, payload) {
    let expensesPaid = payload.response.data.data
    expensesPaid.forEach(element => {
      element.suma_total_items = 0
      element.gst_expenses_items.forEach(elements => {
        element.suma_total_items = parseFloat(elements.total_mxn) + element.suma_total_items
      })
    })
    payload.event.context.expensesPaid = expensesPaid
    payload.event.context.loadingDataTable = false
  },
  onGetDownload (state, payload) {
    payload.event.context.forceFileDownload(payload.response.data, 'expensesPaid.xlsx')
    payload.event.context.loadingDownload = false
  },
   onDownloadFilesERPZip (state, payload) {
    if (payload.response.status !== 200) {
      payload.event.context.loadingDownload = false
      payload.event.context.showNotification(payload.response.message, 'error', -1)
      return
    }
    
    payload.event.context.close()
    payload.event.context.forceFileDownload(payload.response.data, `Layout.${payload.event.typeArchive}`)
    payload.event.context.loadingDownload = false
  },
  onError (state, payload) {
    const error = payload.error

    payload.event.context.loadingItems = false
    payload.event.context.loadingDataTable = false
    payload.event.context.loadingDownload = false
    
    if (error.message === 'Network Error' && !error.response) { 
      return payload.event.context.showNotification(payload.event.context.$t('general.errorChargeDataByRangeDate'), 'error', -1)
    }
    
    if (error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(error.response, 'error', -1)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/expensesPaid.js